export const SEND_EMAIL = gql`
  mutation CreateEmail($input: CreateEmailInput!) {
    createEmail(input: $input) {
      emailId
      subject
      body
      from
      to
      createdAt
      updatedAt
    }
  }
`

export const EXCHANGE_AUTH_TOKEN = gql`
  mutation ExchangeAuthToken($input: ExchangeAuthTokenInput!) {
    exchangeAuthToken(input: $input) {
      emailConnected
    }
  }
`

export const SEND_CUSTOM_EMAIL = gql`
  mutation SendCustomEmail($input: SendCustomEmailInput!) {
    sendCustomEmail(input: $input) {
      sent
    }
  }
`
export const BULK_EMAIL = gql`
  mutation BulkEmail($applicants: [String!]!, $emailTemplateId: String!) {
    bulkEmail(applicants: $applicants, emailTemplateId: $emailTemplateId) {
      applicants {
        applicantId
        success
        errorMsg
      }
    }
  }
`
